import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

// Styles
const styles = StyleSheet.create({
    page: {
        padding: 16,
        fontSize: 10,
        fontFamily: 'Helvetica',
        lineHeight: 1.3,
    },
    watermark: {
        position: 'absolute',
        top: '40%',             // Vertically center
        left: '-50%',           // Shift to the left to prevent clipping
        fontSize: 100,          // Large enough
        color: '#00000020',     // Light watermark
        transform: 'rotate(-45deg)',
        zIndex: -1,             // Keep behind main content
        width: '200%',          // Ensure full rotation fits
        textAlign: 'center',
    },
    // Header
    header: {  fontFamily: 'Times-Roman',textAlign: 'center', fontSize: 13, fontWeight: 'bold', marginBottom: 6 },
    subHeader: {  fontFamily: 'Times-Roman', textAlign: 'center', fontWeight: 'bold', fontSize: 10, marginBottom: 6 },
    receiptHeader: {  fontFamily: 'Times-Roman', textAlign: 'center', fontWeight: 'bold', fontSize: 10, marginBottom: 8 },
    // Application Row
    appRow: {
        flexDirection: 'row',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#000',
        marginBottom: 8,
        fontWeight: 'bold',
    },
    appCell: {
        width: '50%',
        padding: 4,
        borderRightWidth: 1,
        borderRightStyle: 'solid',
        borderRightColor: '#000',
        fontWeight: 'bold',
    },
    appCellLast: {
        width: '50%',
        padding: 4,
        fontWeight: 'bold',
    },
    blue: { color: '#0074c1', fontWeight: 'normal' },
    // Section Title
    sectionTitle: {
        fontWeight: 'bold',
        backgroundColor: '#fff',
        padding: 4,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#000',
        borderBottomWidth: 0,
    },
    // Candidate Table
    table: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#000',
        marginBottom: 8,
    },
      table2: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#000',
        marginBottom: 8,
        borderBottomWidth:0
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: '#000',
    },
    tableRowNoBorder: {
        flexDirection: 'row',
    },
    cell: {
        padding: 4,
        borderRightWidth: 1,
        borderRightStyle: 'solid',
        borderRightColor: '#000',
        minHeight: 16,
        justifyContent: 'center',
    },
    cellLast: {
        padding: 4,
        minHeight: 16,
        justifyContent: 'center',
    },
    cell25: { width: '25%' },
    cell50: { width: '50%' },
    cell75: { width: '75%' },
    cell100: { width: '100%' },
    label: { fontWeight: 'bold' },
    // Subject Table
    subjHeader: {
        fontWeight: 'bold',
        textAlign: 'center',
        backgroundColor: '#fff',
    },
    subjCell: { textAlign: 'center' },
    cell10: { width: '10%' },
    cell40: { width: '40%' },
    cell15: { width: '15%' },
    cell175: { width: '17.5%' },
    // Payment Table
    payCell: { width: '20%', textAlign: 'center' },

    // Declaration
    declaration: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#000',
        marginTop: 8,
    },
    declarationTitle: {
        fontWeight: 'bold',
        padding: 4,
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: '#000',
        backgroundColor: '#fff',
    },
    declarationText: {
        padding: 6,
        fontSize: 9,
        textAlign: 'left',
    },
    signatureRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end', // Ensures both boxes align at the bottom
        marginTop: 60, // Adjust as needed
        paddingHorizontal: 20,
        marginBottom: 8,
    },
    signatureBox: {
        width: 220,
        height: 40, // Ensures both boxes have same height
        alignItems: 'flex-end', // Align signature line to the bottom
        justifyContent: 'flex-end',
    },
    signatureBoxRight: {
        width: 220,
        height: 40,
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
    },
    signatureLine: {
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: '#000',
        width: '100%',
        marginBottom: 3,
        height: 0,
    },
    signatureLabel: {
        fontSize: 10,
        textAlign: 'center',
        width: '100%',
    },
      signatureLabel2: {
        fontSize: 10,
        textAlign: 'center',
        width: '100%',
        color: 'white'
    },
    separator: { borderBottom: "1 solid black", marginVertical: 5 },
    section: { marginBottom: 4 },
});

function ScrutinyPDF({ data }) {
    const student = data?.studentGroup1?.[0] || {};
    const subjects = data?.studentGroup2 || [];
    const payments = data?.studentGroup3 || [];

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {/* <Text style={styles.watermark}>PENDING</Text> */}
                 {Array.isArray(payments) && payments.length === 0  ? 
                (<Text style={styles.watermark}>PENDING</Text>) : ""
                }
                {/* Header */}
                <Text style={styles.header}>JHARKHAND ACADEMIC COUNCIL, RANCHI</Text>
               <Text style={styles.subHeader}>Annual Intermediate Examination - 2026</Text>
                <Text style={styles.receiptHeader}>Scrutiny Application Payment Receipt</Text>
                {/* Application Row */}

                <View style={styles.separator} />

                <View style={{ flexDirection: "row", justifyContent: "space-between", marginBottom: '-5px' }}>
                    <Text style={styles.section}>
                        <Text >APPLICATION NO : </Text> <Text style={styles.label}>{student.APPLICATION_NO}</Text>
                    </Text>
                    <Text style={styles.section}>
                        <Text>APPLICATION DATE : </Text>  <Text style={styles.label}>{student.APPLY_DATE}</Text>
                    </Text>
                </View>
                <View style={styles.separator} />
                {/* Candidate Details */}
                <Text style={styles.sectionTitle}>Candidate Details :</Text>
                <View style={styles.table}>
                    {/* Row 1 */}
                    <View style={styles.tableRow}>
                        <Text style={[styles.cell, styles.cell50]}><Text style={styles.label}>Roll Code :</Text></Text>
                        <Text style={[styles.cell, styles.cell50]}><Text>{student.RollCode}</Text> </Text>
                        <Text style={[styles.cell, styles.cell50]}><Text style={styles.label}>Roll Number : </Text> </Text>
                        <Text style={[styles.cellLast, styles.cell50]}><Text>{student.RollNo}</Text></Text>
                    </View>
                    <View style={styles.tableRow}>
                        <Text style={[styles.cell, styles.cell50]}><Text style={styles.label}>Registration No. :</Text> </Text>
                        <Text style={[styles.cell, styles.cell50]}><Text>{student.RegnNo}</Text> </Text>
                        <Text style={[styles.cell, styles.cell50]}><Text style={styles.label}>Date of Birth :</Text> </Text>
                        <Text style={[styles.cellLast, styles.cell50]}><Text>{student.DOB}</Text></Text>
                    </View>
                    {/* Row 2 */}
                    <View style={styles.tableRow}>
                        <Text style={[styles.cell, styles.cell25]}><Text style={styles.label}>Name of the Candidate :</Text></Text>
                        <Text style={[styles.cellLast, styles.cell75]}>{student.CandidateName}</Text>
                    </View>
                    {/* Row 3 */}
                    <View style={styles.tableRow}>
                        <Text style={[styles.cell, styles.cell25]}><Text style={styles.label}>Mother’s Name :</Text></Text>
                        <Text style={[styles.cellLast, styles.cell75]}>{student.MotherName}</Text>
                    </View>
                    {/* Row 4 */}
                    <View style={styles.tableRow}>
                        <Text style={[styles.cell, styles.cell25]}><Text style={styles.label}>Father’s Name :</Text></Text>
                        <Text style={[styles.cellLast, styles.cell75]}>{student.FatherName}</Text>
                    </View>
                    {/* Row 5 */}
                    <View style={styles.tableRow}>
                        <Text style={[styles.cell, styles.cell25]}><Text style={styles.label}>Mobile Number :</Text></Text>
                        <Text style={[styles.cellLast, styles.cell75]}>{student.MOBILE_NO || ""}</Text>
                    </View>
                    {/* Row 6 */}
                    <View style={styles.tableRow}>
                        <Text style={[styles.cell, styles.cell25]}><Text style={styles.label}>Email ID :</Text></Text>
                        <Text style={[styles.cellLast, styles.cell75]}>{student.EMAIL_ID || ""}</Text>
                    </View>
                    {/* Row 7 */}
                    <View style={styles.tableRow}>
                        <Text style={[styles.cell, styles.cell25]}><Text style={styles.label}>School Name :</Text></Text>
                        <Text style={[styles.cellLast, styles.cell75]}>{student.SchoolName}</Text>
                    </View>
                    {/* Row 8 */}
                    <View style={styles.tableRowNoBorder}>
                        <Text style={[styles.cell, styles.cell25]}><Text style={styles.label}>School District :</Text></Text>
                        <Text style={[styles.cellLast, styles.cell75]}>{student.SchDistName}</Text>
                    </View>
                </View>

                {/* Subject(s) Details */}
                <Text style={styles.sectionTitle}>Subject(s) Details :</Text>
                <View style={styles.table2}>
                    <View style={styles.tableRow}>
                        <Text style={[styles.cell, styles.cell10, styles.subjHeader]}>Sl. No.</Text>
                        <Text style={[styles.cell, styles.cell40, styles.subjHeader]}>Subject Code & Name</Text>
                        <Text style={[styles.cell, styles.cell15, styles.subjHeader]}>Subj. Type</Text>
                        <Text style={[styles.cell, styles.cell175, styles.subjHeader]}>Full Marks in Theory</Text>
                        <Text style={[styles.cellLast, styles.cell175, styles.subjHeader]}>Obtained Marks in Theory</Text>
                    </View>
                    {Array.from({ length: 6 }).map((_, index) => {
                        const subject = subjects && subjects.length > index ? subjects[index] : null;
                        return (
                            <View style={styles.tableRow} key={index}>
                                <Text style={[styles.cell, styles.cell10, styles.subjCell]}>{subject?.SUBJECT_CODE_NAME ? index + 1 : ''}</Text>
                                <Text style={[styles.cell, styles.cell40, styles.subjCell]}>
                                    {subject?.SUBJECT_CODE_NAME ?? ''}
                                </Text>
                                <Text style={[styles.cell, styles.cell15, styles.subjCell]}>
                                    {subject?.SUBJECT_TYPE ?? ''}
                                </Text>
                                <Text style={[styles.cell, styles.cell175, styles.subjCell]}>
                                    {subject?.FULL_MARKS_THEORY ?? ''}
                                </Text>
                                <Text style={[styles.cellLast, styles.cell175, styles.subjCell]}>
                                    {subject?.OBTAIN_MARKS_THEORY ?? ''}
                                </Text>
                            </View>
                        );
                    })}

                </View>

                {/* Payment Details */}
                <Text style={styles.sectionTitle}>Payment Details :</Text>
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <Text style={[styles.cell, styles.payCell, styles.subjHeader]}>Payment Mode</Text>
                        <Text style={[styles.cell, styles.payCell, styles.subjHeader]}>Amount in Rs.</Text>
                        <Text style={[styles.cell, styles.payCell, styles.subjHeader]}>Payment Date & Time</Text>
                        <Text style={[styles.cell, styles.payCell, styles.subjHeader]}>Merchant Ref. No.</Text>
                        <Text style={[styles.cellLast, styles.payCell, styles.subjHeader]}>Bank Ref. No.</Text>
                    </View>
                    {Array.isArray(payments) && payments.length > 0 ? (
                        payments.map((payment, index) => (
                            <View style={styles.tableRowNoBorder} key={index}>
                                <Text style={[styles.cell, styles.payCell, styles.subjCell]}>{payment.PAYMENT_MODE}</Text>
                                <Text style={[styles.cell, styles.payCell, styles.subjCell]}>{payment.TRANSACTION_AMOUNT}</Text>
                                <Text style={[styles.cell, styles.payCell, styles.subjCell]}>{payment.RESPONSE_DATE_TIME}</Text>
                                <Text style={[styles.cell, styles.payCell, styles.subjCell]}>{payment.SURE_PAY_TXN_ID}</Text>
                                <Text style={[styles.cellLast, styles.payCell, styles.subjCell]}>{payment.BANK_TRANSACTION_NO}</Text>
                            </View>
                        ))
                    ) : (
                        <View style={styles.tableRowNoBorder}>
                            <Text
                                style={{
                                    textAlign: 'center',
                                    flex: 1,
                                    // borderWidth: 1,
                                    borderColor: '#000',
                                    padding: 6,
                                    fontSize: 10,
                                }}
                            >
                                Payment Incomplete
                            </Text>
                        </View>
                    )}
                </View>


                <View style={styles.declaration}>
                    <Text style={styles.declarationTitle}>Declaration by Candidate :</Text>
                    <Text style={styles.declarationText}>
                        I hereby declare that all the details given above are true, complete and correct to the best of my knowledge and belief and in the event of any information being found false/incorrect my candidature would stand cancelled without any further notice.
                    </Text>
                    <View style={styles.signatureRow}>
                        <View style={styles.signatureBox}>
                            <View style={styles.signatureLine} />
                            <Text style={styles.signatureLabel2}>Signature </Text>
                        </View>
                        <View style={styles.signatureBoxRight}>
                            <View style={styles.signatureLine} />
                            <Text style={styles.signatureLabel}>Signature of the Candidate</Text>
                        </View>
                    </View>
                </View>

                {/* Signature */}



            </Page>
        </Document>
    );
}
export default ScrutinyPDF;